import produce from 'immer';

import {
  ENTITY_ICONS_FETCH_FAILURE,
  ENTITY_ICONS_FETCH_SUCCESS,
  ENTITY_INTEGRATION_FIELDS_FAILURE,
  ENTITY_INTEGRATION_FIELDS_SUCCESS,
  ENTITY_SECTION_CREATE_FAILURE,
  ENTITY_SECTION_CREATE_SUCCESS,
  ENTITY_SECTION_EDIT_FAILURE,
  ENTITY_SECTION_EDIT_SUCCESS,
  ENTITY_SECTION_FETCH_FAILURE,
  ENTITY_SECTION_FETCH_SUCCESS,
  ENTITY_SECTIONS_FETCH_FAILURE,
  ENTITY_SECTIONS_FETCH_SUCCESS,
} from '@actions/entitySection';

const initialState: IEntitySectionStore = {
  entityIcons: [],
  entitySections: null,
  currentEntitySection: null,
  isFetching: false,
  error: null,
  entityIntegrationFields: {},
};

export default (state: IEntitySectionStore = initialState, action: any) =>
  produce(state, (draftState: IEntitySectionStore) => {
    switch (action.type) {
      case ENTITY_SECTION_FETCH_SUCCESS:
      case ENTITY_SECTION_CREATE_SUCCESS:
      case ENTITY_SECTION_EDIT_SUCCESS:
        draftState.isFetching = false;
        draftState.currentEntitySection = action.response;
        draftState.error = null;

        return;

      case ENTITY_SECTION_FETCH_FAILURE:
      case ENTITY_SECTION_CREATE_FAILURE:
      case ENTITY_SECTION_EDIT_FAILURE:
      case ENTITY_SECTIONS_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case ENTITY_SECTIONS_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.entitySections = action.response;
        draftState.error = null;

        return;

      case ENTITY_INTEGRATION_FIELDS_SUCCESS:
        draftState.isFetching = false;
        draftState.entityIntegrationFields = action.response;
        draftState.error = null;

        return;

      case ENTITY_ICONS_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.entityIcons = action.response;
        draftState.error = null;

        return;

      case ENTITY_ICONS_FETCH_FAILURE:
      case ENTITY_INTEGRATION_FIELDS_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;
    }
  });
